import { gql } from '@apollo/client';

export const GET_BILL_TYPE_FEE_ITEM_CONFIGS = gql`
  query GetBillTypeFeeItemConfigs(
    $billType: BillTypeEnum
    $clientId: ID
    $businessScenarioCode: Long
  ) {
    getBillTypeFeeItemConfigs(
      billType: $billType
      clientId: $clientId
      businessScenarioCode: $businessScenarioCode
    ) {
      id
      settlementClientId
      billType
      feeItemId
      feeItemName
      feeItemCode
      businessScenarioCode
      isRequired
      displayOrder
      isEnabled
      createdAt
    }
  }
`;

export const UPDATE_FEE_ITEM_ORDER = gql`
  mutation UpdateFeeItemOrder($billType: BillTypeEnum!, $configs: [BillTypeFeeItemConfigInput!]!) {
    updateFeeItemOrder(billType: $billType, configs: $configs)
  }
`;

export const TOGGLE_FEE_ITEM_STATUS = gql`
  mutation ToggleFeeItemStatus($configId: ID!, $enabled: Boolean!) {
    toggleFeeItemStatus(configId: $configId, enabled: $enabled)
  }
`;

export const ADD_FEE_ITEM_CONFIG = gql`
  mutation AddFeeItemConfig(
    $clientId: ID!
    $billType: BillTypeEnum!
    $feeItemId: ID!
    $businessScenarioCode: Long!
  ) {
    addFeeItemConfig(
      clientId: $clientId
      billType: $billType
      feeItemId: $feeItemId
      businessScenarioCode: $businessScenarioCode
    )
  }
`;

export const REMOVE_FEE_ITEM_CONFIG = gql`
  mutation RemoveFeeItemConfig($configId: ID!) {
    removeFeeItemConfig(configId: $configId)
  }
`;

export const GET_ALL_SETTLEMENT_FEE_ITEMS = gql`
  query GetAllSettlementFeeItems($businessScenarioCode: Long) {
    allOptions: getAllSettlementFeeItem(businessScenarioCode: $businessScenarioCode) {
      ...SelectOptionFields
      __typename
    }
  }
  
  fragment SelectOptionFields on SelectOptionType {
    value
    label
    __typename
  }
`;
